import phoneIcon from "../../../assets/phone.svg";
import classes from "./input.module.css";
import { useTranslation } from "../../../I18n/Languages/LanguageContext";

const PhoneIcon = () => (
  <img src={phoneIcon} alt="phone" style={{ width: 16, height: 16 }} />
);

const CustomPhoneInput = ({
  name,
  value = "",
  onChange,
  onBlur,
  label,
  topLabel,
  placeholder,
  error,
  helperText,
  disabled,
}) => {
  const { t } = useTranslation();
  return (
    <div className={classes.inputWrapper}>
      {topLabel && <label className={classes.topLabel}>{topLabel}</label>}
      <div className={classes.inputContainer}>
        <div className={classes.countryCodeSection}>
          <span className={classes.countryCode}>+355</span>
        </div>
        <input
          type="tel"
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder || t('enter_phone_number') || label}
          disabled={disabled}
          className={classes.input}
          autoComplete="tel"
          inputMode="numeric"
          pattern="[0-10]*"
          maxLength={10}
        />
        <span className={classes.phoneIconEnd}>
          <PhoneIcon />
        </span>
      </div>

      {helperText && (
        <div
          className={`${classes.helperText} ${
            error ? classes.helperTextError : ""
          }`}
        >
          {helperText}
        </div>
      )}
    </div>
  );
};

export default CustomPhoneInput;
